import React, { useState } from "react";
import ActionItem from "../components/ActionItem";

import Header from "../components/Header";
import Modal from "../components/Modal";
import LayoutContent from "../components/LayoutContent";
import PasswordScreen from "@bd-components/PasswordScreen";
import DetectFontChange from "../components/DetectFontChange";

const PasswordPage = ({ wheelData, login }) => {
  const [onOpen, setOpen] = useState(false);
  const [fonts, setFonts] = useState(null);

  const onOpen_about = () => {
    setOpen(true);
  };

  const onClose_about = () => {
    setOpen(false);
  };

  const forceRerenderWheel = textStyle => {
    setFonts(textStyle);
  };

  return (
    <LayoutContent>
      <DetectFontChange onChange={forceRerenderWheel} />
      <Header
        aboutButton={{
          text: window.main_button.about_button
            ? window.main_button.about_button
            : "About",
          background: window.themes?.secondary_use_single_color
            ? window.themes.secondary_color
            : `linear-gradient(${
                window.themes?.secondary_color_gradient?.direction
              }, ${
                window.themes?.secondary_color_gradient?.gradient_colors[0]
                  ?.color
              } 0%, ${
                window.themes?.secondary_color_gradient?.gradient_colors[1]
                  ?.color
              } 100%)`,
          onClick: onOpen_about
        }}
        visibility="hidden"
      />
      <Modal isOpen={onOpen} onClose={onClose_about}>
        <h3 className="modal-inner-title">{window.about.title}</h3>
        <div
          className="modal-inner-content"
          dangerouslySetInnerHTML={{ __html: window.about.text }}
        />
      </Modal>
      <PasswordScreen
        loginButton={{
          text: window.password_page.password_submit_button,
          color: window.button_color.text_login_color,
          background: window.themes.primary_color
        }}
        password={window.backend.choose_pw}
        wheel={{
          isCustomLogo: window.button.custom_button_spinner,
          buttonText: window.button.button_spinner,
          buttonLogo: window.button.button_spinner_logo,
          buttonColor: window.button_color.text_spin_color,
          buttonBg: window.button_color.button_spin_color,
          textStyle: fonts
        }}
        categoryList={window.categories}
        members={wheelData}
        invalidText={window.button.invalid_password}
        login={login}
      />
    </LayoutContent>
  );
};

export default PasswordPage;
